import { z } from 'zod';

export const all = async (params: object): Promise<MetadataType[]> => {
	let queryString = '';
	if (params) {
		const paramsAsString = JSON.stringify(params)
			.replace(/:/g, '=')
			.replace(/,/g, '&')
			.replace(/[{}"]/g, '');

		const searchParams = new URLSearchParams(paramsAsString);
		queryString = `?${searchParams.toString()}`;
	}

	const response = await fetch(`/MetadataType${queryString}`);

	return await response.json();
};

export const add = async (metadataType: MetadataType): Promise<boolean> => {
	const res = await fetch(`/MetadataType`, {
		method: 'POST',
		body: JSON.stringify(metadataType),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};

export const update = async (metadataType: MetadataType): Promise<boolean> => {
	const res = await fetch(`/MetadataType`, {
		method: 'PATCH',
		body: JSON.stringify(metadataType),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};
export const MetadataTypeSchema = z.object({
	id: z.number().nullable(),
	name: z.string().nonempty({ message: 'A metadata name is required.' }),
	slug: z.string().nullable(),
	deletedOn: z.date().nullable(),
});

export type MetadataType = z.infer<typeof MetadataTypeSchema>;
